import React from "react";
import { cls } from "cls";

interface NavMenuItemProps {
  imageUrl?: string;
  title: string;
  backgroundColor: string;
  url: string;
}

const NavMenuItem = ({
  imageUrl,
  title,
  backgroundColor,
  url,
}: NavMenuItemProps) => {
  return (
    <div
      id="nav-menu-item"
      className={`${cls(
        "flex",
        "flex-col",
        "items-center",
        "space-y-2",
        "sm:space-y-4",
      )}
        w-[120px]
        sm:w-[140px]
      `}
    >
      <a href={url} aria-label={title}>
        {imageUrl ? (
          <img
            id="nav-img"
            aria-hidden="true"
            className={`
            ${cls(
              "bg-gray-50",
              "rounded-full",
              "hover:cursor-pointer",
              "hover:brightness-75",
            )}
            h-[120px]
            w-[120px]
            sm:h-[140px]
            sm:w-[140px]
        `}
            src={imageUrl}
            alt=""
          />
        ) : (
          <div
            id="menu-initial"
            className={`
            ${cls(
              "bg-gray-50",
              "rounded-full",
              "flex",
              "font-bold",
              "items-center",
              "justify-center",
              "text-5xl",
              "text-black",
              "hover:cursor-pointer",
              "hover:bg-gray-100",
            )}
            h-[120px]
            w-[120px]
            sm:h-[140px]
            sm:w-[140px]
            `}
            style={{ color: backgroundColor }}
          >
            {title[0]}
          </div>
        )}
      </a>
      <p
        className={`${cls(
          "m-0",
          "text-center",
          "leading-tight",
        )} [text-wrap:balance]`}
        style={{ textDecoration: "none", color: "#272C25" }}
      >
        {title}
      </p>
    </div>
  );
};

export default NavMenuItem;
